module.exports = __webpack_public_path__ + "static/media/educators-02.a3acc79b.jpg";